import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
  } from "@mui/material";
  import React from "react";
  import "./Table.scss";
  
  const SingleSelect = ({
    label,
    list,
    selectedValue,
    handleChange,
  }) => {
    return (
      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <FormControl size="small" sx={{ minWidth: 220 }}>
          <InputLabel>{label}</InputLabel>
  
          <Select
            value={selectedValue}
            onChange={handleChange}
            input={<OutlinedInput label={label} />}
            renderValue={(value) => {
              const selectedOption = list.find((opt) => opt.id === value);
              return selectedOption ? selectedOption.name : "";
            }}
          >
            <MenuItem key="select" value="">
                Select
            </MenuItem>
            {list.map((opt) => (
              <MenuItem key={opt.id} value={opt.id}>
                {opt.name}
              </MenuItem>
            ))}
          </Select>
  
        </FormControl>
      </Box>
    );
  };
  
  export default SingleSelect;